import localforage from 'localforage';

export const CHATROOM_PREFIX = 'chatroom_v13_';

export const chatStore = localforage.createInstance({
  driver: localforage.INDEXEDDB,
  name: 'chatroom',
  storeName: 'messages',
  description: 'Anchor messages',
});

// Merge newly fetched deleted-announcement data into the cached one.
// Each key (deleted_announcement / hidden_announcements ...) is an array of
// announcement ids, so we concat + dedupe.
export const mergeDeletedAnnouncements = (oldData, newData) => {
  const merged = { ...(oldData || {}) };
  Object.keys(newData || {}).forEach((key) => {
    const oldArr = Array.isArray(merged[key]) ? merged[key] : [];
    const newArr = Array.isArray(newData[key]) ? newData[key] : [];
    merged[key] = [...new Set([...oldArr, ...newArr])];
  });
  return merged;
};
